import React from 'react';

import { Typography } from '@mui/material';
import type { GridCellParams } from '@mui/x-data-grid-premium';
import { formatDateForDisplay } from 'src/helpers';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(_theme => ({
  container: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
  },
}));

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type DateCellParams = GridCellParams<Record<string, any>, string | Date>;

export function WorkflowListDateCell({ value }: DateCellParams): JSX.Element {
  const { classes } = useStyles();

  return (
    <div className={classes.container}>
      <Typography variant="body1">{formatDateForDisplay(value)}</Typography>
    </div>
  );
}
